<template>
    <div>
        <h4 class="p-2">Capacidad de aula vs alumno asignados en aula</h4>
        <form autocomplete="off" @submit.prevent="getAulaVsAlumno('online')">
            <vs-row class="mt-4">
                <vs-col sm="12" lg="3">
                    <vs-select label="Institución" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="3">
                    <vs-select label="Ciclo escolar" :loading="loadingCicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloEscolarId" v-model="cicloEscolar" :disabled="!cicloEscolares.length">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <vs-option v-for="(option, index) in cicloEscolares" :key="index"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col w="12">
                    <vs-button
                        class="ml-auto"
                        type="submit"
                    >
                        <i class="fas fa-search mr-2"></i> Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
        </form>
        <!-- <vs-button
            v-if="edificios.length"
            class="ml-auto mt-4 mb-4"
            success
            flat
            @click="getAulaVsAlumno('file')"
        >
            Descargar excel
        </vs-button> -->
        
        <aula-alumno v-if="edificios.length" :edificios="edificios"></aula-alumno>
        <h5 class="text-center mt-5" v-else>Sin información</h5>
    </div>
</template>

<script>
import general from '../../../../api/requests/general'
import academico from '../../../../api/requests/academico'
import AulaAlumno from './tabla-aula-vs-alumno.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstituto: false,
            cicloEscolar:'',
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            loadingCicloEscolar: false,
            tipo: '',
            errorFields: [],
            edificios: []
        }
    },
    components:{
        AulaAlumno
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async getAulaVsAlumno(tipo){
            const loading = this.$vs.loading()
            try{
                const params = {
                    plantel_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    type_response: tipo
                }
                const { data: response} = await academico.getAulaVsAlumno(params)
                console.log(response)
                this.edificios = response
                loading.close()
            }catch{

            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await general.getInstituciones()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch(error){
                this.loadingInstituto = false
                console.log(error)
            }
        },
        async getCiclosEscolares(){
            if(this.institucion){
                try {
                    this.loadingCicloEscolar = true
                    const response = await academico.getAulaVsAlumnoCicloEscolar(this.institucion)
                    this.cicloEscolares = response.data
                    this.cicloEscolarId = (new Date()).getTime()
                    this.loadingCicloEscolar = false
                }
                catch(error){
                    this.loadingCicloEscolar = false
                    console.log(error)
                }
            }
        },
    },
    watch:{
        institucion(){
           this.getCiclosEscolares()
        }
    }
}
</script>